
define('text!TescoMobile_Checkout/template/minicart/item/product-labels.html',[],function () { return '<!-- ko if: elems() --><div class="product-labels"><!-- ko foreach: {data: elems(), as: \'elem\' } --> <!-- ko template: elem.getTemplate() --><!-- /ko --><!-- /ko --></div><!-- /ko -->';});

